import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EnrollmentTable from '@activities/components/tables/enrollment-table/enrollment-table.vue';
import { Enrollment } from '@activities/interfaces/enrollment';

@Component({
  name: 'bpc-enrollment-table-input',
  components: {
    'bpc-enrollment-table': EnrollmentTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class EnrollmentTableInput extends mixins(AbstractField) {
  @Prop(Array) readonly value: any[];

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default' })
  readonly formConfigName: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;
  @Prop({ type: String, default: 'default' }) readonly filterConfigName: string;
  @Prop(Object) readonly externalFormModel: object;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  // TO-DO: Make this generic for every field
  get activityGroupId(): number {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return Number(filter['value']);
    } else {
      return null;
    }
  }

  public entity: Enrollment = null;
  public entityName = 'enrollment';
  public pluralEntityName = 'enrollments';
  public permissionEntityNameToUse = 'enrollments';

  onChange($event) {
    this.$emit('change', $event);
  }

  get mode(): string {
    return 'api';
  }
}
